import type { JSX } from 'react';
import type {
  AvailabilityFiltersState,
  RangeBounds,
} from '@/routes/publicProperties/availabilitiesFilters';
import type {
  AvailabilitiesFilterControlsContent,
  AvailabilitiesFiltersContent,
} from '@/lib/types/siteSettings';
import { AvailabilitiesFilterControls } from './AvailabilitiesFilterControls';

interface AvailabilitiesDesktopFiltersProps {
  filters: AvailabilityFiltersState;
  onChange: (next: AvailabilityFiltersState) => void;
  assetTypeOptions: string[];
  activeFilterCount: number;
  hasActiveFilters: boolean;
  onReset: () => void;
  filtersContent: AvailabilitiesFiltersContent;
  filterControlsContent: AvailabilitiesFilterControlsContent;
  monthlyRentBounds: RangeBounds | null;
}

export function AvailabilitiesDesktopFilters({
  filters,
  onChange,
  assetTypeOptions,
  activeFilterCount,
  hasActiveFilters,
  onReset,
  filtersContent,
  filterControlsContent,
  monthlyRentBounds,
}: AvailabilitiesDesktopFiltersProps): JSX.Element {
  const activeLabel = filtersContent.activeTemplate.replace(
    '{count}',
    activeFilterCount.toString(),
  );

  return (
    <aside className="hidden xl:sticky xl:top-28 xl:block xl:self-start">
      <div className="rounded-3xl border border-surface-subtle bg-white p-6 shadow-card">
        <div className="mb-4 flex items-center justify-between gap-3">
          <div>
            <p className="text-sm font-semibold text-brand-primary">{filtersContent.title}</p>
            <p className="text-xs text-text-primary/60">{filtersContent.subtitle}</p>
            <p className="text-xs text-text-primary/60">
              {hasActiveFilters ? activeLabel : filtersContent.emptyLabel}
            </p>
          </div>
          <button
            type="button"
            onClick={onReset}
            disabled={!hasActiveFilters}
            className="text-xs font-semibold uppercase tracking-wide text-brand-primary transition disabled:opacity-50"
          >
            {filtersContent.resetLabel}
          </button>
        </div>

        <AvailabilitiesFilterControls
          value={filters}
          onChange={onChange}
          assetTypeOptions={assetTypeOptions}
          content={filterControlsContent}
          monthlyRentBounds={monthlyRentBounds}
        />
      </div>
    </aside>
  );
}
